<template>
  <VanBtn class="plain-btn" size="large" :class="{ border: border }">
    <slot></slot>
  </VanBtn>
</template>

<script>
import { Button as VanBtn } from "vant";
export default {
  name: "PlainBtn",
  props: {
    border: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  components: {
    VanBtn
  }
};
</script>

<style lang="scss" scoped>
.plain-btn {
  width: 90px;
  height: 40px;
  line-height: 40px;
  font-size: 13px;
  color: #222222;
  &.border {
    border-color: #37343d;
  }
}
</style>
